import { Box, Flex, Heading, Text } from '@chakra-ui/react';

const STATS_GRADIENT = 'linear-gradient(60deg, #031643 0%, #00298C 50%, #007D9F 100%)';

const STATS = [
  { value: '84', suffix: '%', label: 'Report positive outcomes' },
  { value: '21', suffix: 'M+', label: 'Learner enrollments' },
  { value: '195', suffix: '', label: 'Different countries reached' },
] as const;

export function PlansStatsSection() {
  return (
    <Box
      borderRadius='12px'
      mb={{ base: 16, lg: 24 }}
      overflow='hidden'
      position='relative'
      px={{ base: 6, md: 12 }}
      py={{ base: 6, md: 12 }}
      style={{ backgroundImage: STATS_GRADIENT }}
      width='full'
    >
      <Box
        boxSize={{ base: '200px', md: '290px' }}
        mixBlendMode='overlay'
        pointerEvents='none'
        position='absolute'
        right={0}
        top={0}
        aria-hidden
      >
        <svg
          fill='none'
          height='100%'
          preserveAspectRatio='xMaxYMin meet'
          viewBox='0 0 290 290'
          width='100%'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g opacity='0.66'>
            <rect fill='#fff' height='520' opacity='0.8' transform='rotate(-45 262 28)' width='26' x='249' y='-232' />
            <rect fill='#fff' height='520' opacity='0.5' transform='rotate(-45 222 68)' width='26' x='209' y='-192' />
            <rect fill='#fff' height='520' opacity='0.2' transform='rotate(-45 182 108)' width='26' x='169' y='-152' />
          </g>
        </svg>
      </Box>

      <Flex direction='column' gap={{ base: 6, md: 10 }} position='relative'>
        <Heading
          as='h2'
          color='white'
          fontFamily='heading'
          fontSize={{ base: '1.75rem', md: '2.25rem' }}
          fontWeight={600}
          letterSpacing='-0.01em'
          lineHeight={1.1}
        >
          Transforming talent across the globe
        </Heading>

        <Flex align='stretch' direction={{ base: 'column', md: 'row' }} gap={{ base: 2, md: 6 }}>
          {STATS.map((stat) => (
            <Box
              key={stat.label}
              bg='rgba(255, 255, 255, 0.24)'
              border='1px solid rgba(255, 255, 255, 0.24)'
              borderRadius={{ base: '4px', md: '8px' }}
              flex={{ base: '0 0 auto', md: '1 0 0' }}
              minW={{ base: 'auto', md: 0 }}
              px={{ base: 4, md: 7 }}
              py={{ base: 3, md: 7 }}
            >
              <Flex
                align={{ base: 'flex-end', md: 'flex-start' }}
                borderColor='#89E6FF'
                borderLeftWidth='2px'
                direction={{ base: 'row', md: 'column' }}
                gap={{ base: 4, md: 3 }}
                pl={{ base: 3, md: 5 }}
                py={{ base: 2, md: 0 }}
              >
                <Text
                  color='white'
                  flexShrink={0}
                  fontFamily='heading'
                  fontWeight={600}
                  lineHeight={1}
                  w={{ base: '65px', md: 'auto' }}
                  whiteSpace='nowrap'
                >
                  <Box as='span' fontSize={{ base: '2rem', md: '2.375rem' }}>
                    {stat.value}
                  </Box>
                  {stat.suffix ? (
                    <Box as='span' fontSize={{ base: '1.375rem', md: '1.625rem' }}>
                      {stat.suffix}
                    </Box>
                  ) : null}
                </Text>
                <Text
                  color='white'
                  fontFamily='body'
                  fontSize={{ base: '0.875rem', md: '0.8125rem' }}
                  fontWeight={{ base: 400, md: 500 }}
                  lineHeight={1.4}
                >
                  {stat.label}
                </Text>
              </Flex>
            </Box>
          ))}
        </Flex>
      </Flex>
    </Box>
  );
}
